export const libraryCard = {
  heroImgAlt: "Conceive logo on peach color",
  title: "Check out more of our <nobr>fertility articles</nobr>",
  topicTitle: "Library",
  topicImgAlt: "Library icon",
};
